<template>
  <div class="main_right">
    <breadcrumb :breadcrumb="config.breadcrumb" />
    <div class="flexBox">
      <text-title mainTitle="查看当前燃气表" subheading="" />
      <div class="header-btn-box">
        <a @click="ToModifyDevice">修改</a>
        <a @click="strategyCenter">返回</a>
      </div>
    </div>
    <form>
      <div class="form-line">
        <div class="line-text">燃气表名称：</div>
        <div>{{ name || '无' }}</div>
      </div>
      <div class="form-line">
        <div class="line-text">燃气表序列号：</div>
        <div>{{ code || '无' }}</div>
      </div>
      <div class="form-line">
        <div class="line-text">燃气表厂家：</div>
        <div>{{ meterDeviceManufacturerName || '无' }}</div>
      </div>
      <div class="form-line">
        <div class="line-text">燃气表型号：</div>
        <div>{{ meterDeviceModelName || '无' }}</div>
      </div>
<!--      <div class="form-line">-->
<!--        <div class="line-text">燃气表类型：</div>-->
<!--        <div>{{ gasDeviceType || '无' }}</div>-->
<!--      </div>-->
      <div class="form-line">
        <div class="line-text">接入方式：</div>
        <div>{{ accessType || '无' }}</div>
      </div>
      <div class="form-line" v-if="accessType === '有线'">
        <div class="line-text">燃气表所属集中器：</div>
        <div>{{ gasControlDeviceName || '无' }}</div>
      </div>
<!--      <div class="form-line">-->
<!--        <div class="line-text">互感器配置：</div>-->
<!--        <div>{{ mutualInductorOnOrOff || '无' }}</div>-->
<!--      </div>-->
<!--      <div class="form-line" v-if="(mutualInductorOnOrOff = '是')">-->
<!--        <div class="line-text">互感器倍率：</div>-->
<!--        <div>{{ powerRate || '无' }}</div>-->
<!--      </div>-->
      <div class="form-line">
        <div class="line-text">燃气表级别：</div>
        <div>{{ levelName || '无' }}</div>
      </div>
      <div class="form-line">
        <div class="line-text">上级燃气表：</div>
        <div>{{ parentDeviceName || '无' }}</div>
      </div>
      <div class="form-line">
        <div class="line-text">燃气表所在楼栋：</div>
        <div>{{ buildingName || '无' }}</div>
      </div>
      <div class="form-line">
        <div class="line-text">燃气表所在房间：</div>
        <div>{{ roomNumber || '无' }}</div>
      </div>
      <div class="form-line">
        <div class="line-text">场景：</div>
        <div>{{ sceneName || '无' }}</div>
      </div>

      <div class="form-line">
        <div class="line-text">初始燃气量：</div>
        <div>{{ gasity || '0' }}立方米</div>
      </div>
      <div class="form-line">
        <div class="line-text">燃气类型：</div>
        <div v-if="useType === '1'">充值</div>
        <div v-if="useType === '2'">抄表</div>
      </div>
<!--      <div class="form-line">-->
<!--        <div class="line-text">通讯类型：</div>-->
<!--        <div>{{ communicationType || '无' }}</div>-->
<!--      </div>-->
      <!--      <div class="form-line" >-->
      <!--        <div class="line-text">燃气表计费：</div>-->
      <!--        <div v-if="gasFeeTypeState">是</div>-->
      <!--        <div v-else>否</div>-->
      <!--      </div>-->
      <div class="form-line" v-if="autoOffSupportState">
        <div class="line-text">欠费是否关闸：</div>
        <div v-if="breaker">是</div>
        <div v-else>否</div>
      </div>
      <!--      <div class="form-line" >-->
      <!--        <div class="line-text">燃气表数据统计：</div>-->
      <!--        <div v-if="whetherToCount">是</div>-->
      <!--        <div v-else>否</div>-->
      <!--      </div>-->
      <div class="form-line">
        <div class="line-text">备注：</div>
        <div>{{ memo || '无' }}</div>
      </div>
    </form>
  </div>
</template>

<script>
import BreadCrumb from '../../../components/common/di-ding/common/bread-crumb'
import { errorHandler } from '../../../utils/errorHandler'
import InputTree from '../../../components/common/inputs/input-tree'
import { api } from '../../api/GasManagement'
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
import TextTitle from '../../../components/Text/TextTitle'
import { nSuccess } from '../../../utils/notice'

export default {
  components: {
    TextTitle,
    Breadcrumb,
    InputTree,
    BreadCrumb,
  },
  name: 'controller-current',
  data() {
    return {
      config: {
        breadcrumb: [
          {
            value: '智慧燃气',
            name: 'gas-over-view',
          },
          {
            value: '燃气表管理',
          },
        ],
      },
      autoOffSupportState: false,
      name: '',
      code: '',
      meterDeviceType: '',
      deviceCode: '',
      meterDeviceManufacturerName: '',
      meterDeviceModelName: '',
      accessType: '',
      gasControlDeviceName: '',
      buildingName: '',
      roomNumber: '',
      sceneName: '',
      useType: '',
      powerOnOrOff: '',
      mutualInductorOnOrOff: '',
      gasity: '',
      memo: '',
      communicationType: '',
      breaker: false,
      whetherToCount: false,
      gasFeeTypeState: false,
      powerRate: '',

      levelList: [
        {
          name: '一级',
          code: 1,
        },
        {
          name: '二级',
          code: 2,
        },
        {
          name: '三级',
          code: 3,
        },
        {
          name: '四级',
          code: 4,
        },
        {
          name: '五级',
          code: 5,
        },
      ],
      levelName: '',
      parentDeviceName: '',
    }
  },
  created() {
    this.autoOffSupport()
    this.deviceCode = this.$route.params.id
    this.getGasMeterDeviceByCode()
  },
  methods: {
    // 查询是否可配置欠费是否关闸
    autoOffSupport() {
      this.$axios
        .get(api.autoOffSupport, {})
        .then((res) => {
          this.autoOffSupportState = res.data.data
        })
        .catch(errorHandler('查询配置信息失败'))
    },
    getGasMeterDeviceByCode() {
      this.$axios
        .get(`${api.getGasMeterDeviceByCode}/${this.deviceCode}`, {})
        .then((res) => {
          let data = res.data.data
          this.name = data.name
          this.code = data.code
          this.sceneName = data.sceneName
          this.useType = data.useType
          this.meterDeviceType = data.meterDeviceType
          this.meterDeviceManufacturerName = data.meterDeviceManufacturerName
          this.meterDeviceModelName = data.meterDeviceModelName
          this.accessType = data.accessType
          this.gasControlDeviceName = data.gasControlDeviceName
          this.buildingName = data.buildingName
          this.powerRate = data.powerRate
          this.roomNumber = data.roomNumber
          this.gasity = data.gasity
          this.communicationType = data.communicationType
          this.powerOnOrOff = data.powerOnOrOff
          this.whetherToCount = data.whetherToCount
          if (data.autoOff === '1') {
            this.breaker = true
          } else {
            this.breaker = false
          }
          if (data.gasFeeType === '1') {
            this.gasFeeTypeState = true
          } else {
            this.gasFeeTypeState = false
          }
          if (data.whetherToCount === '1') {
            this.whetherToCount = true
          } else {
            this.whetherToCount = false
          }
          if (data.mutualInductorOnOrOff === '0') {
            this.mutualInductorOnOrOff = '否'
          } else {
            this.mutualInductorOnOrOff = '是'
          }
          this.memo = data.memo

          this.levelList.map((v) => {
            if (data.level === v.code) {
              this.levelName = v.name
            }
          })
          this.parentDeviceName = data.parentDeviceName
        })
        .catch(errorHandler('获取燃气表数据失败'))
    },
    strategyCenter() {
      this.$router.push({
        name: 'gas-ammeter-management',
      })
    },
    ToModifyDevice() {
      this.$router.push({
        path: '/gas_ammeter_modify/' + this.$route.params.id,
      })
    },
  },
}
</script>

<style scoped>
.flexBox {
  display: flex;
  justify-content: space-between;
}
.header-btn-box {
  margin: 20px 0 10px 0;
  color: #337ab7;
  font-size: 14px;
}
.header-btn-box a {
  margin-right: 40px;
  cursor: pointer;
}
.header-btn-box a:hover {
  color: #00a0e6;
}
form {
  width: 90%;
  margin: 0 auto;
  text-align: left;
}
.form-line {
  margin: 20px 0;
  display: flex;
  justify-content: flex-start;
}
.line-text {
  color: #48576a;
  font-size: 14px;
  margin-right: 10px;
  width: 160px;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/view/GasManage/AmmeterManagement/AmmeterCurrent.vue